import { render } from "./MyPageEmailSettingsDone.vue?vue&type=template&id=2be352e4&scoped=true&ts=true"
import script from "./MyPageEmailSettingsDone.vue?vue&type=script&lang=ts"
export * from "./MyPageEmailSettingsDone.vue?vue&type=script&lang=ts"

import "./MyPageEmailSettingsDone.vue?vue&type=style&index=0&id=2be352e4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be352e4"]])

export default __exports__